import Vue from 'vue';
import authResources from './resources';
import errorTransformer from '../shared/transformers/errorTransformer';
import normalizeNumbers from '@/utils/normalizeNumbers';

function login(data) {
  return authResources.login({}, data).then(({ body }) => body);
}

function logout() {
  return authResources.logout();
}

function getUserData() {
  return authResources.userData().then(({ body }) => body);
}

function refresh() {
  return authResources.refresh();
}

function verifyOTP({ otp, token }) {
  Vue.http.headers.common['Authorization'] = `Bearer ${token}`;
  return authResources
    .verifyOTP({}, { otp: normalizeNumbers(otp) })
    .then(({ body }) => body)
    .catch(errorTransformer);
}

function verifySMSCode({ code, token }) {
  Vue.http.headers.common['Authorization'] = `Bearer ${token}`;
  return authResources
    .verifySMSCode({}, { code: normalizeNumbers(code) })
    .then(({ body }) => body)
    .catch(errorTransformer);
}

function resendSMS(token) {
  Vue.http.headers.common['Authorization'] = `Bearer ${token}`;
  return authResources
    .resendSMS({}, {})
    .then(({ body }) => body)
    .catch(errorTransformer);
}

export default {
  login,
  logout,
  refresh,
  getUserData,
  verifyOTP,
  verifySMSCode,
  resendSMS,
};
